import { render, staticRenderFns } from "./CommunicationRow.vue?vue&type=template&id=050e03e7&scoped=true"
import script from "./CommunicationRow.vue?vue&type=script&lang=ts"
export * from "./CommunicationRow.vue?vue&type=script&lang=ts"
import style0 from "./CommunicationRow.vue?vue&type=style&index=0&id=050e03e7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "050e03e7",
  null
  
)

export default component.exports